import { mount } from 'svelte';
import App from './App.svelte';
import './styles.css';
import { DatabaseClient } from './lib/db/database-client.svelte';
import { reconcileServiceWorkers } from './lib/pwa/service-worker';
import {
  createMockDatabaseClient,
  usesMockDatabaseFixture,
} from './lib/testing/mock-database.svelte';

const database =
  typeof window !== 'undefined' && usesMockDatabaseFixture(window.location.search)
    ? createMockDatabaseClient()
    : new DatabaseClient();

mount(App, {
  target: document.getElementById('app')!,
  props: { database },
});

void reconcileServiceWorkers();
